// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"text-inline-image_wrapper__Zr_45","imageLeft":"text-inline-image_imageLeft__rGn5k","imageWrapper":"text-inline-image_imageWrapper__s_agM"};